// src/App.jsx
import React, { Suspense } from "react";
import ErrorBoundary from "./components/ErrorBoundry";
import store from "./store/store";
import { BrowserRouter } from "react-router-dom";
import Routing from "./utils/routes";
import { Provider } from "react-redux";
import { Bounce, ToastContainer } from "react-toastify";

const AppContainer = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Suspense fallback={"Loading..."}>
          <BrowserRouter>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick={false}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              transition={Bounce}
            />

            <Routing />
          </BrowserRouter>
        </Suspense>
      </Provider>
    </ErrorBoundary>
  );
};

export default AppContainer;
